const updateGroupsStr = {
  toastr: 'Grupo atualizado',
  toastr1: 'foi atualizado com sucesso',
  toastrError: 'Nome já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default updateGroupsStr;
